import React from 'react';
import { connect } from 'react-redux';
import {
  getEvents,
  toggleRepetition,
  toggleAll,
  getAccounts,
  getAccount,
  toggleSector,
  toggleAllSectors,
  toggleBenefit,
  toggleAllBenefitsInAccordion,
  toggleAllBenefits,
  clearSectors,
  syncStorageEvents,
  finishReceiveEvents,
  validateMenuEvents,
  clearEvents,
} from '../../store/actions';
import { checkMaxExhibitions } from '../../helpers/uhuu';

export default function withCreateUhuuMenu(WrappedComponent) {
  const mapStateToProps = state => ({
    events: state.events.list,
    isLoading: state.events.isLoading,
    accounts: state.events.accounts,
    account: state.events.account,
    isReceiveAccountFinished: state.events.isReceiveAccountFinished,
    isReceiveEventsFinished: state.events.isReceiveEventsFinished,
  });

  const mapDispatchToProps = dispatch => ({
    getEvents: idAccount => dispatch(getEvents(idAccount)),
    getAccounts: () => dispatch(getAccounts()),
    getAccount: id => dispatch(getAccount(id)),
    toggleRepetition: (exibithionId, repetitionId) =>
      dispatch(toggleRepetition(exibithionId, repetitionId)),
    toggleAll: exibithionId => dispatch(toggleAll(exibithionId)),
    toggleSector: (sectorId, repetitions) => dispatch(toggleSector(sectorId, repetitions)),
    toggleAllSectors: repetitions => dispatch(toggleAllSectors(repetitions)),
    toggleBenefit: (sectorId, benefitId) => dispatch(toggleBenefit(sectorId, benefitId)),
    toggleAllBenefitsInAccordion: sectorId => dispatch(toggleAllBenefitsInAccordion(sectorId)),
    toggleAllBenefits: repetitions => dispatch(toggleAllBenefits(repetitions)),
    clearSectors: () => dispatch(clearSectors()),
    finishReceiveEvents: () => dispatch(finishReceiveEvents()),
    syncStorageEvents: events => dispatch(syncStorageEvents(events)),
    validateMenuEvents: (menus, accId, saleType, idMenu) =>
      dispatch(validateMenuEvents(menus, accId, saleType, idMenu)),
    clearEvents: () => dispatch(clearEvents()),
  });
  /* eslint-disable react/prop-types */
  const CreateMenuContainer = props => {
    const selectRepetition = ({ exibithionId, repetitionId }) => {
      if (checkMaxExhibitions(props.events, exibithionId)) {
        props.toggleRepetition(exibithionId, repetitionId);
      }
    };

    const selectSector = (sector, repetitions) => {
      props.toggleSector(sector.id, repetitions);
    };

    const selectBenefit = (benefit, sectorId) => {
      props.toggleBenefit(sectorId, benefit.id);
    };

    const toggleAll = exibithionId => {
      if (checkMaxExhibitions(props.events, exibithionId)) {
        props.toggleAll(exibithionId);
        props.clearSectors();
      }
    };

    return (
      <WrappedComponent
        {...props}
        selectRepetition={selectRepetition}
        selectSector={selectSector}
        selectBenefit={selectBenefit}
        toggleAll={toggleAll}
      />
    );
  };
  /* eslint-enable */

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateMenuContainer);
}



// WEBPACK FOOTER //
// ./src/containers/CreateUhuuMenu/index.js